import { render, staticRenderFns } from "./BatchpaintlistPage.vue?vue&type=template&id=283c3e8b"
import script from "./BatchpaintlistPage.vue?vue&type=script&lang=js"
export * from "./BatchpaintlistPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports